import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'substring',
  standalone: true
})
export class SubstringPipe implements PipeTransform {

  transform(value: string, length: number): string {
    if (!value) return '';
    if (value.length > length) {
      return value.substring(0, length) + '...';
    } else {
      return value;
    }
  }

}
